import { useState } from "react";
import { supabase } from "../lib/supabase";
import { MascotAvatar } from "../components/MascotAvatar";
import { EyebrowPill } from "../components/StatusPill";

export default function Login() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleLogin(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: window.location.origin },
    });
    setLoading(false);
    if (error) setError(error.message);
    else setSent(true);
  }

  return (
    <div className="flex h-screen items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-3">
          <MascotAvatar size={56} />
          <div>
            <EyebrowPill>Internal tool</EyebrowPill>
            <h1 className="mt-1 font-display text-2xl font-semibold tracking-display">
              LMT <span className="text-text-muted">DM Setter</span>
            </h1>
          </div>
        </div>

        <div className="rounded-2xl border border-border bg-bg-panel p-7 shadow-card">
          {sent ? (
            <div className="rounded-lg border border-status-qualified/30 bg-status-qualified/10 p-4 text-sm">
              ✓ Check ton email à <strong className="text-text">{email}</strong> pour le magic link.
            </div>
          ) : (
            <form onSubmit={handleLogin} className="space-y-4">
              <div>
                <label className="mb-1.5 block text-xs font-medium uppercase tracking-wider text-text-muted">
                  Email
                </label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="louis@letmetalk.ai"
                  className="w-full rounded-lg border border-border bg-bg px-3.5 py-2.5 text-text placeholder:text-text-dim focus:border-accent-500 focus:outline-none focus:ring-2 focus:ring-accent-500/30"
                />
              </div>
              {error && (
                <div className="rounded-md border border-status-disqualified/30 bg-status-disqualified/10 px-3 py-2 text-xs text-status-disqualified">
                  {error}
                </div>
              )}
              <button
                type="submit"
                disabled={loading || !email}
                className="w-full rounded-lg bg-accent-500 px-4 py-2.5 text-sm font-semibold text-white shadow-glow transition-opacity hover:bg-accent-600 disabled:opacity-50"
              >
                {loading ? "Envoi..." : "Envoyer le magic link"}
              </button>
            </form>
          )}
        </div>

        <p className="mt-4 text-center text-xs text-text-dim">
          Single sign-on via Supabase Auth.
        </p>
      </div>
    </div>
  );
}
